import { render } from "./ModalEliminarCuenta.vue?vue&type=template&id=58bce544&scoped=true"
import script from "./ModalEliminarCuenta.vue?vue&type=script&lang=js"
export * from "./ModalEliminarCuenta.vue?vue&type=script&lang=js"

import "./ModalEliminarCuenta.vue?vue&type=style&index=0&id=58bce544&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bce544"]])

export default __exports__